import './css/styles.css';

const includeFragments = async () => {
  const includeTargets = Array.from(document.querySelectorAll('[data-include]'));

  await Promise.all(includeTargets.map(async target => {
    const response = await fetch(target.dataset.include);
    if (!response.ok) throw new Error(`HTML 조각을 불러오지 못했습니다: ${target.dataset.include}`);
    target.outerHTML = await response.text();
  }));

  await import('./js/scripts');
  await document.fonts?.ready;
};

includeFragments()
  .catch(error => {
    console.error(error);
    document.body.insertAdjacentHTML('beforeend', '<p class="include-error">페이지를 불러오지 못했습니다. 새로고침해 주세요.</p>');
  })
  .finally(() => {
    requestAnimationFrame(() => document.documentElement.classList.remove('app-loading'));
  });
